// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".c-spdm-red[data-v-af42a490]{color:#ba052a}.c-spdm-white[data-v-af42a490]{color:#fff}#isAdmin[data-v-af42a490]{border-top:7px solid #ba052a;bottom:0;height:7px;position:fixed;top:0;width:100vw;z-index:10}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
